import { Button, showAlert } from '@beehive/components';
import React, { useState } from 'react';
import Template from '../components/Template';
import { NodeEnum, getListPathMenuKey } from 'containers/OutBidding/utils';
import { transformToBlobIds } from '../utils';
import _ from 'lodash';

/**
 * 评估中（比选评审）
 */
const BidOpenReview = (props: any) => {
  const { detail = {}, editFields = [], getDetail, projectMove } = props;
  const [loading, setLoading] = useState(false);

  const { permit_actions = {} } = detail;
  const canMove = permit_actions.can_move;
  const hasSubmitted = !!canMove && !!detail?.bidding_suppliers?.[0].bidding_supplier_quotes?.[0]?.created_at

  const handleSubmit = async (validData: any) => {
    const params = validData();
    if (params) {
      setLoading(true);
      const { evaluationValues } = params;
      const {
        tender_plan_attach_blob_ids,
        quote_price,
        quote_currency,
        quote_price_attach_blob_ids,
      } = evaluationValues;
      const { bidding_suppliers = [] } = detail;
      const [currentSupplier] = bidding_suppliers;
      const { bidding_supplier_quotes = [] } = currentSupplier;
      const [currentQuote = {}] = bidding_supplier_quotes;
      const data = {
        bidding_supplier_id: detail.current_bidding_supplier_id,
        quote_price_attach_blob_ids: transformToBlobIds(
          quote_price_attach_blob_ids
        ),
        quote_price,
        quote_currency,
      };
      try {
        await projectMove(
          {
            id: detail.id,
            pass: true,
            form: {
              ...data,
            },
            state: NodeEnum.BID_OPEN_REVIEW,
            bidding_action: 'SUBMIT',
          },
          {
            menuKey: getListPathMenuKey(),
          }
        );
        showAlert({ type: 'success', message: '提交成功' });
        getDetail();
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Template
      detail={detail}
      editFields={editFields}
      hasSubmitted={hasSubmitted}
      renderOpers={(validData: any) => {
        return (
          <>
            {canMove ? (
              <Button
                onClick={() => handleSubmit(validData)}
                type="primary"
                loading={loading}
                disabled={loading}
              >
                提交
              </Button>
            ) : null}
          </>
        );
      }}
    />
  );
};

export default BidOpenReview;
